import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import { BirthdayField } from './birthday-field';
import { validateBirthday } from './helpers';
import type { TFormBirthday, IDeps } from './models';
import { FormBirthday as Component } from './form-birthday';

export const FormBirthday = createWidget<IDeps, TFormBirthday>({
    Field,
    BirthdayField,
    validateBirthday,
    getCaption,
    isSuccess,
    isError,
})(Component);
